import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { CurrentUserService } from '../current-user/current-user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../session/session.service';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { StepsService } from '@shared/services/steps/steps.service';
import { UrlQueryStringService } from '@shared/services/url-query-string/url-query-string.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  baseUrl = environment.apiUrl;
  moduleName;

  constructor(
    private http: HttpClient,
    private router: Router,
    private _currentUser: CurrentUserService,
    private _sessionService: SessionService,
    private _sessionStorageService: SessionStorageService,
    private _stepsService: StepsService,
    private _urlQueryStringService: UrlQueryStringService,
    private activatedRoute: ActivatedRoute
  ) {}

  login(userName: string, password: string, returnUrl: string = '/') {
    return this.http
      .post<any>(`${this.baseUrl}/sign-in`, {
        userName,
        password
      })
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && user.token) {
            const obj = {
              username: user.username,
              isLogin: true
            };

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(obj));
            this._sessionService.setToken(user.token);
            if (user.isEAC) {
              this._sessionStorageService.setSession(`EAC`, 1);
            } else {
              this._sessionStorageService.removeSession(`EAC`);
            }
            this._currentUser.loanUserInfo().then(() => {
              this._stepsService.setSession('step_id', user.stepId);
              this._stepsService.setSession('username', user.username);
              user.stepId === 1
                ? this.router.navigate(['/signup'])
                : this.router.navigate([returnUrl]);
            });
            return true;
          }

          return false;
        })
      );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this._sessionService.removeToken();
    this._stepsService.removeSession('step_id');
    this._sessionStorageService.removeSession(`firstname`);
    this._sessionStorageService.removeSession(`verification_status`);
    this._urlQueryStringService.removeEAC();
    this._urlQueryStringService.removePromoDiscount();
  }
}
